import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import { LOCAL_BUSINESS } from "@/lib/structured-data";

export const Route = createFileRoute("/contact")({
  head: () => {
    const base = seo({
      title: "Contact",
      description:
        "Call (715) 418-3887 or request a quote. SeaClay in Prairie Farm, WI serving Northwest Wisconsin — a straight answer, no sales pitch.",
      path: "/contact",
    });
    return {
      ...base,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            name: "Contact SeaClay Roofing & Spray Foam Insulation",
            url: "https://seaclaysprayfoam.com/contact",
            mainEntity: LOCAL_BUSINESS,
          }),
        },
      ],
    };
  },
});
